// Cart View
export enum CART_VIEW_MODES {
  CART_VIEW_DRAWER = 'drawer',
  CART_VIEW_CARD = 'card',
}
